import React from 'react'
import { useField } from 'formik'
import { TextField, Typography, makeStyles, InputAdornment, IconButton } from '@material-ui/core'
import { InfoRounded } from '@material-ui/icons'
import Tooltip from '@material-ui/core/Tooltip'
import { Fade } from '@mui/material'

const CustomTextField = ({ infoText, ...props }) => {
  const classes = useStyles()
  const [field, meta] = useField(props)
  const errorText = meta.error && meta.touched ? meta.error : ''

  return (
    <TextField
      className={props.disabled ? classes.disabled : ''}
      helperText={errorText}
      error={!!errorText}
      fullWidth
      variant="outlined"
      {...field}
      {...props}
      InputProps={{
        endAdornment: (
          <>
            {infoText && (
              <InputAdornment position="end">
                <Tooltip
                  arrow
                  TransitionComponent={Fade}
                  title={<Typography className={classes.tooltip}>{infoText}</Typography>}>
                  <IconButton className={classes.infoIconBtn}>
                    <InfoRounded className={classes.infoIcon} />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            )}
          </>
        )
      }}
    />
  )
}

export default CustomTextField

const useStyles = makeStyles({
  disabled: {
    '& .MuiFormLabel-root': {
      color: '#616161'
    },
    '& .MuiInputBase-root': {
      color: '#616161'
    },
    backgroundColor: '#eeeeee',
    borderRadius: '10px'
  },
  tooltip: {
    padding: '3px',
    fontSize: '13px'
  },
  infoIcon: {
    color: '#1e88e5'
  },
  infoIconBtn: {
    padding: '2px'
  }
})
